import { Fetch } from "../../utilities/Fetch";

export class LogEmailService {

	findLogEmailForPedido(id) {
		return Fetch.GetJSON(`/logs-email/pedido/${id}`);
	}

}
